declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';


import { FieldData, AutoGenBool } from '../../../../../models/actor/actor';


@Component({
    selector: 'auto-gen-boolpv',
    templateUrl: './autogenboolpv.component.html',
    styleUrls: ['./autogenboolpv.component.scss']
})

export class AutoGenBoolPVComponent implements OnInit {
    @Input() public mode;
    @Input() public Data: AutoGenBool;
    @Input() public field: FieldData;
    ngOnInit(): void {
        //alert('from bool' + this.mode);
    }

    get isChecked(): boolean {
        return (this.field != null && this.field.Value == 'True') ;
    }

    @Input('isChecked')
    set isChecked(value: boolean) {
        this.field != null
        {
          //  alert(this.field.Title + " before: " + this.field.Value + "  , New Value = " + value);
            if (value)
                this.field.Value = 'True';
            else
                this.field.Value = 'False';

          //  alert(this.field.Title + " After: " + this.field.Value );
        }
    }



}
